import React, {useEffect, useState} from 'react';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Colors } from '../../../styles';

const HttpRequest = (props) => {

    return (
        <>
            <div
                style={{
                    backgroundColor:'#4F93E8',
                    borderRadius:5
                }}
            >
                <Container>
                    <div style={{display:'flex'}}>
                        <p
                            style={{
                                color:'white',
                                fontFamily:'monospace',
                                marginLeft:12,
                                marginTop:6
                            }}
                        >URL: {props.requestType + ' ' + props.url}</p>
                    </div>
                    <div style={{}}>
                        <p
                            style={{
                                color:'white',
                                fontFamily:'monospace',
                                marginLeft:12
                            }}
                        >{props.headers[0]}</p>
                        <p
                            style={{
                                color:'white',
                                fontFamily:'monospace',
                                marginLeft:12,
                            }}
                        >{props.headers[1] ? props.headers[1] : ''}</p>
                        <p
                            style={{
                                color:'white',
                                fontFamily:'monospace',
                                marginLeft:12,
                            }}
                        >{props.headers[2] ? props.headers[2] : ''}</p>
                        {
                            props.body ?
                            <p
                                style={{
                                    color:'white',
                                    fontFamily:'monospace',
                                    marginLeft:12,
                                }}
                            >{'Body: ' + props.body}</p> : ''
                        }
                    </div>
                </Container>
            </div>
        </>
    );
};

export default HttpRequest;